import React from "react";
import styles from "./IMF.module.scss";

import { messages } from "../Delivery.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const IMF: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      <div key={1} className={styles.carouselItem}>
        <h3 className={styles.title}>{formatMessage(messages.imfTitle)}</h3>
        <ui.Scrollbars>
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.imfDescription1) }}></p>
        </ui.Scrollbars>
      </div>
    </div>
  );
};
